import React from 'react';
import { useNavigate } from 'react-router-dom';
import useWorkflowStore from '../stores/useWorkflowStore';
import { useShallow } from 'zustand/shallow';
import SocketTypeSelectionModal from './SocketTypeSelectionModal';

const AppWrapper = ({ children }) => {
  const navigate = useNavigate();
  const [showSocketTypeModal, hideSocketTypeSelectionModal, handleSocketTypeContinue] = useWorkflowStore(
    useShallow((state) => [
      state.showSocketTypeModal,
      state.actions.hideSocketTypeSelectionModal,
      state.actions.handleSocketTypeContinue
    ])
  );

  const handleModalClose = () => {
    hideSocketTypeSelectionModal();
  };

  const handleModalContinue = (selectedType) => {
    const nextRoute = handleSocketTypeContinue(selectedType);
    if (nextRoute) {
      navigate(nextRoute);
    }
  };

  return (
    <>
      {children}
      <SocketTypeSelectionModal
        isOpen={showSocketTypeModal}
        onClose={handleModalClose}
        onContinue={handleModalContinue}
      />
    </>
  );
};

export default AppWrapper; 